define('bizzabo/views/right/EditQuestionView',[
    'jquery',
    'backbone',
    'underscore',
    'bizzabo/config',
    'bizzabo/utils',
    'bizzabo/consts',
    'bizzabo/models/Global',
    'bizzabo/models/AnswersCollection',
    'bizzabo/models/Answer',
    'bizzabo/views/FormMixin',
    'bizzabo/views/ModelBindingMixin',
    'bizzabo/views/CollectionView',
    'hbars!bizzabo/templates/editPollQuestion',
    'hbars!bizzabo/templates/pollAnswer',
    'hbars!bizzabo/templates/editPollQuestionTop'
], function(
    $,
    Backbone,
    _,
    CONFIG,
    UTILS,
    Consts,
    Global,
    AnswersCollection,
    Answer,
    FormMixin,
    ModelBindingMixin,
    CollectionView,
    editPollQuestionTemplate,
    pollAnswerTemplate,
    editPollQuestionTopTemplate
    ) {

    var EditQuestionView = Backbone.View.extend({
        events : {
            'change input[type="checkbox"]' : 'formRequiredQuestionChanged',
            'change input[name="resultType"]' : 'formResultTypeChanged',
            'change input[name="questionType"]' : 'formQuestionTypeChanged',
            'change .scaleSelect' : 'scaleSelectChanged',
            'click .addAnswerButton' : 'addAnswerButtonClicked',
            'click .saveQuestionButton' : 'saveQuestionButtonClicked',
            'click .deleteQuestionButton' : 'deleteQuestionButtonClicked',
            'keyup' : 'clickIfEnter'
        },

        initialize : function(options) {
            this.poll = options.poll;
            this.pollsView = options.pollsView;
            _.bindAll(this, 'deleteSuccess');

            this.answersCollection = this.model.get('choices') ? this.model.get('choices') : new AnswersCollection();
            this.oldAnswersCollection = undefined;

            if (this.answersCollection.length === 0) {
                //Add two empty answers
                this.answersCollection.set([{},{}]);
            }

            this.model.set('choices', this.answersCollection);
            this.model.bindToAnswersModel();

            this.answersCollectionView = new AnswersCollectionView({
                model: this.answersCollection
            });

            this.topEditQuestionView = new TopEditQuestionView({
                model: this.model
            });

            this.listenTo(Global.modelPool.getActiveEvent(), 'change:event-is-active', this.disableViewIfNeed);
        },

        scaleSelectChanged : function() {
            var numOfAnswers = this.$('.scaleSelect').val();
            var numberOfActions = this.answersCollection.length - numOfAnswers;
            var action = this.answersCollection.length > numOfAnswers ? 'remove' : 'add';
            var i;

            if (action === 'remove') {
                for(i = 0; i < numberOfActions; i++) {
                    this.answersCollection.pop();
                }
            } else {
                numberOfActions = -numberOfActions;
                for(i = 0; i < numberOfActions; i++) {
                    this.answersCollection.push(new Answer());
                }
            }

        },

        formQuestionTypeChanged : function(options) {
            var value = this.$('input[name="questionType"]:checked').val();
            this.model.set('type', value);
            switch (value) {
                case 'choices':
                    this.answersCollection.set(this.oldAnswersCollection ? this.oldAnswersCollection.models : this.answersCollection.models);
                    this.$('.edit-question-answer-text-holder').toggleClass('hide', true);
                    this.$('.edit-question-answer-holder').toggleClass('hide', false);
                    this.$('.edit-question-scale-select').toggleClass('hide', true);
                    this.$('.show-results-wrapper').toggleClass('hide', false);
                    break;
                case 'text':
                    this.$('.edit-question-answer-text-holder').toggleClass('hide', false);
                    this.$('.edit-question-answer-holder').toggleClass('hide', true);
                    this.$('.edit-question-scale-select').toggleClass('hide', true);
                    this.$('.show-results-wrapper').toggleClass('hide', true);
                    break;
                case 'scale':
                    if (!options.dontScale) {
                        this.oldAnswersCollection = this.answersCollection.clone();
                        this.answersCollection.set(this.generateScaleAnswers());
                    }
                    this.$('.edit-question-scale-select').toggleClass('hide', false);
                    this.$('.edit-question-answer-text-holder').toggleClass('hide', true);
                    this.$('.edit-question-answer-holder').toggleClass('hide', false);
                    this.$('.show-results-wrapper').toggleClass('hide', false);
                    break;
                default:
            }
        },

        generateScaleAnswers : function() {
            var answers = [];
            for (var i = 0; i < 5; i++) {
                answers.push(new Answer({text: i + 1 + ''}));
            }

            answers[0].set('text', '1 - Lowest');
            answers[4].set('text', '5 - Highest');

            return answers;
        },

        deleteQuestionButtonClicked : function() {
            this.model.destroy();
            this.remove();
            if (this.poll.isAllModelValid(true)) {
                this.savePoll();
                this.pollsView.hideDetails();
            } else {
                Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                    msg : "You have an invalid question, fix your errors and save the poll",
                    autoHide : true,
                    errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.ERROR
                });
            }
        },

        deleteSuccess : function() {

        },

        saveQuestionButtonClicked : function() {
            if(this.$('.saveQuestionButton').hasClass('disabled')) {
                return;
            }

            if (this.model.isAllModelValid(true)) {
                var questionType = this.model.get('type');
                if (questionType === 'text') {
                    if (this.model.get('choices')) {
                        var model;
                        while (model = this.model.get('choices').first()) {
                            model.destroy();
                        }
                    }
                    this.model.unset('choices');
                }
                this.savePoll();
            } else {
                Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                    msg : "The question is invalid",
                    autoHide : true,
                    errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.ERROR
                });
            }
        },

        savePoll : function() {
            this.poll.save({}, {
                success: function() {
                    Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                        msg : 'Poll successfully saved',
                        errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.SUCCESS,
                        autoHide : true
                    });
                },
                error: function() {
                    Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                        msg : 'Error saving poll',
                        errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.ERROR,
                        autoHide : true
                    });
                }
            });
        },

        remove : function() {
            this.topEditQuestionView.removeModelBinding();
            this.topEditQuestionView.removeValidation();
            this.answersCollectionView.remove();
            this.off();
            this.$el.remove();
        },

        addAnswerButtonClicked : function() {
            var newModel = new Answer();
            this.answersCollection.add(newModel);
            if (!this.model.has('choices')) {
                this.model.set('choices', this.answersCollection);
            }

            UTILS.UI.focusOnField(this.$('.edit-answer-name').last());
        },

        formResultTypeChanged : function() {
            var value = this.$('input[name="resultType"]:checked').val();
            this.model.set('result-type', value);
        },

        formRequiredQuestionChanged : function(e) {
            var checkBox = this.$(e.target);
            var oldState = checkBox.attr('checked');
            var field = checkBox.attr('value');
            this.model.set(field, !oldState);
            checkBox.parent().toggleClass('checkedBox', !oldState);
            checkBox.attr('checked', !oldState);
        },

        formDragFinished : function(modelCid, index) {
            var answersCollection = this.answersCollectionView.model;
            var model = answersCollection.get(modelCid);
            answersCollection.remove(model, {
                silent : true
            });
            answersCollection.add(model, {
                silent : true,
                at : index
            });

            answersCollection.updateModelsIndex();
        },

        clickIfEnter : function(e) {
            if(e.keyCode === 13){
                this.$(':focus').click();
            }
        },

        disableViewIfNeed : function() {
            if (Global.modelPool.getActiveEvent() && Global.modelPool.getActiveEvent().get('event-is-active')) {
                this.$('input').attr('disabled', 'disabled');
                this.$('.button').toggleClass('disabled', true);
                this.$('.addAnswerButton, .deleteQuestionButton, .single-answer-trash').toggleClass('hide', true);
                this.$('.edit-question-answer-multiple').sortable('disable');
            } else {
                this.$('input').removeAttr('disabled', 'disabled');
                this.$('.button').toggleClass('disabled', false);
                this.$('.addAnswerButton, .deleteQuestionButton, .single-answer-trash').toggleClass('hide', false);
                this.renderSortable();
                this.$('.edit-question-answer-multiple').sortable('enable');
            }
        },

        renderSortable : function() {
            var containerEl = this.$('.edit-question-answer-multiple');
            var thisView = this;
            containerEl.sortable({
                start : function(event, ui) {
                    var cid = ui.item.find(".cid").val();
                },

                stop : function(event, ui) {
                    var cid = ui.item.find(".cid").val();
                    var index = ui.item.index();
                    thisView.formDragFinished(cid, index);
                }
            });
        },

        render : function() {
            var html = editPollQuestionTemplate(this.model.toJSON());
            this.$el.html(html);
            this.topEditQuestionView.setElement(this.$('.edit-question-top'));
            this.topEditQuestionView.render();
            this.answersCollectionView.setElement(this.$('.edit-question-answer-multiple'));
            this.answersCollectionView.render();
            this.formQuestionTypeChanged({'dontScale': true});
            this.renderSortable();
            this.disableViewIfNeed();
            return this;
        }
    });

    var TopEditQuestionView = Backbone.View.extend({
        initialize : function() {
            UTILS.mixIntoMe(this, FormMixin); // mixin standard form & validation
            UTILS.mixIntoMe(this, ModelBindingMixin); // mixin model binding

            this.listenTo(Backbone, Consts.Notifications.rightPanel.SWITCHED, this.onReady);

            this.initModelBinding();
            this.initValidation();
        },
        render : function() {
            var html = editPollQuestionTopTemplate(this.model.toJSON());
            this.$el.html(html);
            this.renderForm();
            return this;
        },

        onReady : function() {
            UTILS.UI.focusOnField(this.$('input[name="text"]'));
        }
    });

    var AnswerView = Backbone.View.extend({
        events : {
            'click .single-answer-trash' : 'deleteAnswer'
        },

        initialize : function() {
            UTILS.mixIntoMe(this, FormMixin); // mixin standard form & validation
            UTILS.mixIntoMe(this, ModelBindingMixin); // mixin model binding

            this.listenTo(this.model, 'change:localPosition', this.render);
            this.listenTo(Backbone, Consts.Notifications.rightPanel.SWITCHED, this.onReady);

            this.initModelBinding();
            this.initValidation();
        },

        deleteAnswer : function() {
            this.model.destroy();
        },

        remove : function() {
            this.removeModelBinding();
            this.removeValidation();
            this.off();
            this.$el.remove();
        },

        render : function() {
            var jsonData = _.extend(this.model.toJSON(), {cid: this.model.cid});
            var html = pollAnswerTemplate(jsonData);
            this.$el.html(html);
            this.renderForm();
            return this;
        },

        onReady : function() {
            var shouldValidate = this.model.wasEdited || this.model.isSynced;
            shouldValidate && this.model.validate();
        }
    });

    var AnswersCollectionView = CollectionView.extend({
        ItemView: AnswerView
    });


    return EditQuestionView;

});
